export default "__VITE_ASSET__ClyuycHH__"